module.exports = __webpack_public_path__ + "img/porad_online_white_icon.ce06fce0.svg";